/**
 * One upload may carry up to 10 files and 30 MB in total. Cloud Run refuses
 * any request over 32 MiB before our code sees it, so 30 MB leaves room for
 * the form's own framing. buyer-service and the gateway hold the same numbers.
 */
export const MAX_UPLOAD_FILES = 10;
export const MAX_UPLOAD_TOTAL_MB = 30;
export const MAX_UPLOAD_TOTAL_BYTES = MAX_UPLOAD_TOTAL_MB * 1024 * 1024;

/** How an upload's limits read on the page. */
export const UPLOAD_LIMIT_LABEL = `up to ${MAX_UPLOAD_FILES} files, ${MAX_UPLOAD_TOTAL_MB} MB in total`;

export const totalBytes = (sizes: number[]): number => sizes.reduce((sum, size) => sum + size, 0);

/** Robbie's refusal when adding these files would take the upload past the total. */
export const overTotalMessage = (): string =>
  `That's more than ${MAX_UPLOAD_TOTAL_MB} MB together — I can take ${MAX_UPLOAD_TOTAL_MB} MB per upload, so send the rest in another one.`;

/**
 * What the document endpoint accepts, and how much of it. Exported because
 * the dashboard's first-run drop zone feeds the SAME endpoint — one list, so
 * the two entry points can never disagree about what a buyer may drop.
 */
export const ACCEPTED_TYPES = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'image/bmp': ['.bmp'],
  'image/tiff': ['.tiff', '.tif'],
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'text/csv': ['.csv'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'text/plain': ['.txt'],
  'application/zip': ['.zip'],
  'application/x-zip-compressed': ['.zip'],
};
